import * as Redux from 'redux'
import * as Request from '../../request'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const emptyViewState: Types.IntegrationMappingsViewState = {
  isFetching: false,
}

const emptyDataState: Types.IntegrationMappingsDataState = {
  actions: [],
  subscribers: [],
  topics: [],
}

type RequestActions = Request.RequestAction<any> & Request.SuccessAction<any>

export const dataReducer =
  (state: Types.IntegrationMappingsDataState = emptyDataState, action: RequestActions) => {
  switch (action.type) {
    case Request.integrationsApiSuccessConstant(Constants.FETCH_EXISTING_MAPPINGS):
      return Utils.split(action.payload.response)
    default:
      return state
  }
}

export const viewReducer =
  (state: any = emptyViewState, action: Actions.FetchExistingMappingsAction) => {
  switch (action.type) {
    case Request.integrationsApiRequestConstant(Constants.FETCH_EXISTING_MAPPINGS):
      return {
        ...state,
        isFetching: true,
      }
    case Request.integrationsApiSuccessConstant(Constants.FETCH_EXISTING_MAPPINGS):
    case Request.integrationsApiErrorConstant(Constants.FETCH_EXISTING_MAPPINGS):
      return {
        ...state,
        isFetching: false,
      }
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  data: dataReducer,
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/integration-mappings/reducer.tsx